import React from "react";
import { Link } from "react-router-dom";
interface LogoProps {
  to?: string;
  compact?: boolean;
}
const LOGO_SRC = "https://cdn.magicpatterns.com/uploads/mZTqWzu3jsAmPwWT8eCXNP/polished-app-icon-logo--a-large-rounded-square-ico.svg";
export function Logo({
  to = "/",
  compact = false
}: LogoProps) {
  return <Link to={to} className="focus-ring flex items-center gap-2.5 rounded-xl" aria-label="PolyLexa home" data-id="element-1201" data-mp="ntgftsfzc6jx">
      {/* The artwork has built-in padding, so it's scaled up inside a clipped square. */}
      <span aria-hidden="true" className="relative grid h-10 w-10 shrink-0 place-items-center overflow-hidden" data-id="element-1202" data-mp="dvaa0zr1yg9s">
        <img src={LOGO_SRC} alt="" className="h-full w-full scale-[1.36] object-contain" draggable={false} data-id="element-1203" data-mp="8xqza9tkclml" />
      </span>
      {!compact && <span className="text-xl font-bold tracking-[-0.02em] text-ink" data-id="element-1204" data-mp="4y029odg199m">PolyLexa</span>}
    </Link>;
}